import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { UrlResp } from './UrlResp';

@Injectable()
export class ClientInitService {


      constructor(private httpclient: HttpClient) { }

      // calls login service
      getClient() {
            return this.httpclient.post<UrlResp>('/client/getClient', {}).map(data => data);
      }

      getNativeWindow() {
            return window;
      }
}
